import React from 'react';
import styled from 'styled-components';
import { Text as RebassText } from 'rebass';
import DynamicComponent from '../dynamic-component';
import { theme } from 'themes';

const {
  canon,
  trafalgar,
  paragon,
  greatPrimer,
  doublePica,
  bodyCopy,
  // pica,
  // code
} = theme.textStyles;

export const Canon = props => (
  <DynamicComponent {...canon} {...props}>
    {props.children}
  </DynamicComponent>
);

export const Trafalgar = props => (
  <DynamicComponent {...trafalgar} {...props}>
    {props.children}
  </DynamicComponent>
);

export const Paragon = props => (
  <DynamicComponent {...paragon} {...props}>
    {props.children}
  </DynamicComponent>
);

export const GreatPrimer = props => (
  <DynamicComponent {...greatPrimer} {...props}>
    {props.children}
  </DynamicComponent>
);

export const DoublePica = props => (
  <DynamicComponent {...doublePica} {...props}>
    {props.children}
  </DynamicComponent>
);

export const BodyCopy = props => (
  <DynamicComponent {...bodyCopy} {...props}>
    {props.children}
  </DynamicComponent>
);

const Text = styled(RebassText)`
  max-width: 650px;
`;

export default Text;
